import { get } from 'lodash-es';

import AE_ICON from '../ui/assets/AE.svg';
import AZ_ICON from '../ui/assets/AZ.svg';
import CN_ICON from '../ui/assets/CN.svg';
import EG_ICON from '../ui/assets/EG.svg';
import GE_ICON from '../ui/assets/GE.svg';
import KG_ICON from '../ui/assets/KG.svg';
import KZ_ICON from '../ui/assets/KZ.svg';
import LK_ICON from '../ui/assets/LK.svg';
import MV_ICON from '../ui/assets/MV.svg';
import MY_ICON from '../ui/assets/MY.svg';
import QA_ICON from '../ui/assets/QA.svg';
import TH_ICON from '../ui/assets/TH.svg';
import TR_ICON from '../ui/assets/TR.svg';
import VN_ICON from '../ui/assets/VN.svg';
import UZ_ICON from '../ui/assets/UZ.svg';
import CZ_ICON from '../ui/assets/CZ.svg';
import DO_ICON from '../ui/assets/DO.svg';
import ID_ICON from '../ui/assets/ID.svg';
import IN_ICON from '../ui/assets/IN.svg';
import IT_ICON from '../ui/assets/IT.svg';
import MG_ICON from '../ui/assets/MG.svg';
import MU_ICON from '../ui/assets/MU.svg';
import RU_ICON from '../ui/assets/RU.svg';
import SC_ICON from '../ui/assets/SC.svg';
import SG_ICON from '../ui/assets/SG.svg';

/**
 * TODO: Get country image by iso code from a link when CDN is ready
 *
 * And preload countries flags for them to prevent white screen of images
 *
 * @see https://tracker.yandex.ru/TOURTEAM-635
 */
const COUNTRY_ID_TO_ICON = {
  1: AE_ICON,
  2: EG_ICON,
  3: QA_ICON,
  4: AZ_ICON,
  5: TR_ICON,
  6: KZ_ICON,
  7: MY_ICON,
  8: MV_ICON,
  9: TH_ICON,
  10: GE_ICON,
  11: LK_ICON,
  12: UZ_ICON,
  13: VN_ICON,
  14: CN_ICON,
  15: KG_ICON,
  17: DO_ICON,
  18: IN_ICON,
  19: ID_ICON,
  20: IT_ICON,
  21: MU_ICON,
  22: RU_ICON,
  23: SC_ICON,
  24: SG_ICON,
  25: MG_ICON,
  26: CZ_ICON,
};

export function getFlagIconByCountryId(countryId: number) {
  return get(COUNTRY_ID_TO_ICON, countryId);
}

/**
 * The same tourflow country ids, spelled as ISO 3166-1 alpha-2 codes — the
 * flag assets above are already named after them.
 *
 * Kept as its own map rather than derived from the icon paths so that a change
 * to how the SVGs are bundled cannot silently break the codes.
 */
const COUNTRY_ID_TO_CODE = {
  1: 'AE',
  2: 'EG',
  3: 'QA',
  4: 'AZ',
  5: 'TR',
  6: 'KZ',
  7: 'MY',
  8: 'MV',
  9: 'TH',
  10: 'GE',
  11: 'LK',
  12: 'UZ',
  13: 'VN',
  14: 'CN',
  15: 'KG',
  17: 'DO',
  18: 'IN',
  19: 'ID',
  20: 'IT',
  21: 'MU',
  22: 'RU',
  23: 'SC',
  24: 'SG',
  25: 'MG',
  26: 'CZ',
};

/**
 * @returns the ISO-2 code of a tourflow country, or `undefined` for an id this
 * map does not know yet.
 */
export function getCountryCodeById(countryId: number): string | undefined {
  return get(COUNTRY_ID_TO_CODE, countryId);
}
